import React from 'react';

import PrepareCustomerResultsJob from 'components/StudyDashboard/ProceduresPage/Actions/PrepareCustomerResultsForDownload';
import { ResultsExportContext } from './useResultsExportContext';

interface PreparedResultsExportFormProps {
  context: ResultsExportContext;
  // Published study results fixes the whole-study published scope; Bundled results keeps scope editable.
  wholeStudyPublishedOnly: boolean;
  onBack: () => void;
  onClose: () => void;
}

export const PreparedResultsExportForm: React.FC<PreparedResultsExportFormProps> = ({
  context,
  wholeStudyPublishedOnly,
  onBack,
  onClose,
}) => (
  <PrepareCustomerResultsJob
    casesParams={{ ...context.casesParams, filters: { ...context.casesParams.filters, studyId: context.studyId } }}
    wholeStudyPublishedOnly={wholeStudyPublishedOnly}
    cancelLabel="Back"
    onClose={(_event, force) => (force ? onClose() : onBack())}
  />
);
